/* global Cookies, LocalStorage, Modal, Notify, Page, Utility, Meters, DataTables */

/** @typedef {import('./namespaces/Cookies') Cookies */
/** @typedef {import('./namespaces/LocalStorage') LocalStorage */
/** @typedef {import('./namespaces/Modal') Modal */
/** @typedef {import('../Scripts/notifications/notify') Notify */
/** @typedef {import('./namespaces/Page') Page */
/** @typedef {import('./namespaces/Utility') Utility */
/** @typedef {import('./namespaces/Meters') Meters */
/** @typedef {import('./namespaces/DataTables') Meters */

var FD = { // eslint-disable-line no-unused-vars
    // Public Properties 
    notify: new Notify(),

    // Public Functions
    init: function () { },

    // Namespaces (Speical Public Properties)
    Cookies: Cookies,
    LocalStorage: LocalStorage,
    Modal: Modal,
    Utility: Utility,
    Page: Page,

    // App Specific Namespaces
    Meters: Meters,
    DataTables: DataTables,
};